__turbopack_context__.v({
  "captionText": "_2hu0uq_captionText",
  "descriptionText": "_2hu0uq_descriptionText",
  "headerContainer": "_2hu0uq_headerContainer",
  "mainHeading": "_2hu0uq_mainHeading",
});
